export { default } from './key-value-list-view';
